module.exports = __webpack_public_path__ + "media/flags/es-4812bd03.gif";